// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"48ff2b67","414":"08abc2fb"}[chunkId] + ".chunk.css";
};